import { Box, Typography } from '@mui/material';
import { withTranslation, WithTranslation } from 'react-i18next';

import ModalBox from '@core/assistant/ModalBox';
import { useAssistant } from '@core/assistant/providers/Provider';
import { SCREENS } from '@core/assistant/interfaces';
import { teleportRegions } from '@core/assistant/voiceCommand';
import TeleportBox from '@core/assistant/TeleportBox';
import Tag from '@core/assistant/Tag';

import { useStyles } from './styles';

const TeleportScreen = ({ t: translate }: WithTranslation) => {
  const classes = useStyles();

  const { setOpen, navigate, setNavigationHistory, stopPlayback } =
    useAssistant();

  const renderTitle = () => {
    return (
      <Box sx={classes.titleBox}>
        <Typography sx={classes.title}>Noa</Typography>
        <Tag />
      </Box>
    );
  };

  return (
    <ModalBox
      title={renderTitle()}
      onClose={() => {
        stopPlayback();
        setOpen(false);
        setNavigationHistory([]);
        navigate(SCREENS.DEFAULT);
      }}
      onBack={() => {
        navigate(SCREENS.DEFAULT, true);
      }}
    >
      <Typography sx={classes.text}>
        {translate('assistant.teleportTo')}
      </Typography>
      <Box sx={classes.questions}>
        {teleportRegions.map((region, index) => (
          <TeleportBox key={index} title={region.ueName || region.name} />
        ))}
      </Box>
    </ModalBox>
  );
};

export default withTranslation('common')(TeleportScreen);
